module.exports = __webpack_public_path__ + "assets/img/triangle2.f64271b8.svg";